import { links } from "../shared/constants/constants"
import styles from "./hero.module.css"
import illustrationPath from "./img/illustration.webp"

const Hero = () => {
	const handleTalkToAi = () => {
		window.location.href = `${links.startupsSignUp}?plan=hiring`
	}

	return (
		<section id="hero" className={styles.heroSection}>
			<div className={styles.heroBg} aria-hidden />
			<div className={styles.heroGrid} aria-hidden />
			<div className={styles.heroShell}>
				<div className={styles.heroInner}>
					<div className={styles.heroCopy}>
						<div className={styles.label}>Agentic HR platform for growing teams</div>
						<h1 className={`${styles.heroHeadline} ${styles.heroHeadlineStack3}`}>
							<span className={styles.heroHeadlineLine}>Build Your Team.</span>
							<span className={styles.heroHeadlineLine}>Manage It Seamlessly.</span>
							<span className={styles.heroHeadlineLine}>All in One Place.</span>
						</h1>
						<p className={styles.heroSub}>
							The agentic HR platform for growing teams. Source from a curated network of individual talents and agencies, then onboard, manage, and scale without switching tools.
						</p>
						<div className={styles.heroActions}>
							<button type="button" className={styles.btnPrimary} onClick={handleTalkToAi}>
								<span>Get Started</span>
								<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
									<path
										d="M5.25 2.625L9.625 7L5.25 11.375"
										stroke="white"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							</button>
							<a href="/#pillars" className={styles.btnGhost}>
								See how it works
							</a>
						</div>
						<p className={styles.heroNote}>No credit card required · 1 AI Sourcing credit every 6 months included on every plan</p>
					</div>

					<div className={styles.illustration}>
						<div className={styles.illustrationFrame}>
							<img src={illustrationPath} alt="" />
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}

export default Hero
